import React, { useState, useRef, useEffect } from 'react';
import Card from 'components/card/Card';
import { Tab, Tabs, TabList, TabPanels, TabPanel, Box } from '@chakra-ui/react';
import { Flex, useToast } from '@chakra-ui/react';
import JoditEditor from 'jodit-react';
// import Branches from './components/stores';
// import About from './components/about';
import { EditIcon, CloseIcon } from '@chakra-ui/icons';
import { useLocation } from 'react-router-dom';
import { Progress } from '@chakra-ui/react';
import SavingPlanVariantApi from 'api/savingplanvariant';
import SavingsPlanApi from 'api/savingplan';
import DetailsForm from './detailsForm';
import TableData from 'views/admin/variantcharges/components/tableData';
import { isValidUUID } from 'utils/fetchUtils';
import { usePermissions } from 'contexts/PermissionContext';
import ContentForm from './contentForm';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import { Modules } from 'config/constant';

export default function AddOrEditPanel(props) {
  console.log('Props', props.SavingplanList);
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [disabled, setDisabled] = useState(state?.data?.id);
  const [variantData, setVariantData] = useState(null);
  const [fetchVariantDataError, setFetchVariantDataError] = useState(false);
  const id = IdFromUrl(window.location.href);
  function IdFromUrl(url) {
    const parts = url.split('/');
    const id = parts[parts.length - 1];
    return id;
  }

  // Form States:-
  const editor = useRef(null);
  const [SavingplanList, setSavingplanList] = useState([]);
  const [error, setError] = useState(false);
  const { getPermissionsForModule } = usePermissions();
  const [editPermissions, setEditPermissions] = useState(null);

  useEffect(() => {
    const permission = getPermissionsForModule([Modules.SavingPlanVariant]);
    setEditPermissions(permission);
  }, [getPermissionsForModule]);

  const FetchSavingsplanList = async () => {
    if (!isValidUUID(id)) {
      return;
    }
    try {
      setLoading(true);
      let response = await SavingsPlanApi.List({
        //  currentPage,
        //  itemsPerPage,
        sort: 'name:asc',
        // searchTerm,
      });
      response = response.data;
      setLoading(false);
      if (response.status_code === 200 && response?.data?.list?.length > 0) {
        console.log(response.data);
        setSavingplanList(response?.data?.list);
      } else {
        setSavingplanList(null);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    FetchSavingsplanList();
  }, []);

  console.log('State passed down', state);

  if (!editPermissions?.update) {
    return <NoPermissionsMessage module={Modules.SavingPlanVariant} />;
  }

  return (
    <>
      <Card
        direction='column'
        w='100%'
        px='20px'
        mt='7rem'
        overflowX={{ sm: 'scroll', lg: 'hidden' }}>
        <Tabs
          isFitted
          variant='enclosed'>
          <TabList mb='1em'>
            <Tab>Plan Details</Tab>
            <Tab>Content</Tab>
            <Tab>Charges</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <>
                <>
                  <Flex direction='column'>
                    <DetailsForm
                      SavingplanList={SavingplanList}
                      withId={true}
                      variantData={variantData}
                      setVariantData={setVariantData}
                      fetchVariantDataError={fetchVariantDataError}
                      setFetchVariantDataError={setFetchVariantDataError}
                    />
                    <Flex
                      direction={{ base: 'column', md: 'column', lg: 'row' }}
                      maxWidth='sm'></Flex>
                  </Flex>
                </>
              </>
            </TabPanel>
            <TabPanel>
              <ContentForm
                variantData={variantData}
                fetchVariantDataError={fetchVariantDataError}
              />
            </TabPanel>
            <TabPanel>
              <TableData withId={true} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Card>
    </>
  );
}
